<template>
  <WorkspaceRoleDenied v-if="staffDenied" :area="t('workspaceFinanceiroServicos.area')" />
  <div v-else class="workspace-financeiro-page ws-fin-servicos">
    <div class="modern-header">
      <div class="header-container">
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              {{ currentWorkspace?.nome || t('workspaceDashboard.defaultName') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('workspaceFinanceiroServicos.breadcrumbCurrent') }}</span>
          </nav>
        </div>

        <div class="title-section">
          <div class="title-content">
            <div class="title-icon">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('workspaceFinanceiroServicos.title') }}</h1>
              <p class="subtitle">{{ t('workspaceFinanceiroServicos.subtitle') }}</p>
            </div>
          </div>

          <div class="workspace-badge" :class="`type-${(currentWorkspace?.tipo || 'SERVICOS').toLowerCase()}`">
            <div class="badge-icon">
              <svg v-if="currentWorkspace?.tipo === 'CRM'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
              </svg>
            </div>
            <span class="badge-text">{{ currentWorkspace?.tipo || 'SERVICOS' }}</span>
          </div>
        </div>

        <div class="actions-section">
          <button
            type="button"
            class="action-button secondary"
            :disabled="loading"
            @click="$router.push(`/workspace/${workspaceId}/clientes`)"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            {{ t('submenu.workspace.clientes') }}
          </button>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div v-if="loading" class="ws-fin-state"><div class="ws-fin-spinner" /><p>{{ t('workspaceFinanceiroServicos.loading') }}</p></div>

      <template v-else>
        <WorkspaceFinanceiroServicosKpi :kpis="kpis" />
        <WorkspaceFinanceiroServicosForecast :forecast="forecast" />

        <div class="ws-fin-filters ws-fin-filters--toolbar">
          <div class="ws-fin-filters__card">
            <div class="ws-fin-filters__toolbar-head">
              <span class="ws-fin-filters__toolbar-icon" aria-hidden="true">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/></svg>
              </span>
              <div>
                <h2 class="ws-fin-filters__toolbar-title">{{ t('workspaceFinanceiroServicos.filters.toolbarTitle') }}</h2>
                <p class="ws-fin-filters__toolbar-sub">{{ t('workspaceFinanceiroServicos.filters.toolbarSub') }}</p>
              </div>
            </div>

            <div class="ws-fin-filters__panel">
              <div class="ws-fin-filters__dates">
                <label class="ws-fin-filters__field ws-fin-filters__field--search">
                  <span class="ws-fin-filters__label">{{ t('workspaceFinanceiroServicos.filters.search') }}</span>
                  <div class="ws-fin-filters__input-wrap">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
                    <input v-model="search" type="search" :placeholder="t('workspaceFinanceiroServicos.filters.searchPlaceholder')" />
                  </div>
                </label>

                <div class="ws-fin-filters__range">
                  <label class="ws-fin-filters__field">
                    <span class="ws-fin-filters__label">{{ t('workspaceFinanceiroServicos.filters.inicio') }}</span>
                    <div class="ws-fin-filters__input-wrap">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                      <input v-model="periodo.inicio" type="date" />
                    </div>
                  </label>
                  <span class="ws-fin-filters__range-sep" aria-hidden="true">{{ t('workspaceFinanceiroServicos.filters.ate') }}</span>
                  <label class="ws-fin-filters__field">
                    <span class="ws-fin-filters__label">{{ t('workspaceFinanceiroServicos.filters.fim') }}</span>
                    <div class="ws-fin-filters__input-wrap">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                      <input v-model="periodo.fim" type="date" />
                    </div>
                  </label>
                </div>

                <label class="ws-fin-filters__field ws-fin-filters__field--sort">
                  <span class="ws-fin-filters__label">{{ t('workspaceFinanceiroServicos.filters.ordenar') }}</span>
                  <div class="ws-fin-filters__input-wrap ws-fin-filters__input-wrap--select">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"/></svg>
                    <select v-model="sortBy">
                      <option value="vencimento">{{ t('workspaceFinanceiroServicos.filters.sortVencimento') }}</option>
                      <option value="valorDesc">{{ t('workspaceFinanceiroServicos.filters.sortValor') }}</option>
                      <option value="atrasoDesc">{{ t('workspaceFinanceiroServicos.filters.sortAtraso') }}</option>
                    </select>
                  </div>
                </label>
              </div>

              <div class="ws-fin-filters__presets" role="group" :aria-label="t('workspaceFinanceiroServicos.filters.periodo')">
                <span class="ws-fin-filters__presets-label">{{ t('workspaceFinanceiroServicos.filters.periodo') }}</span>
                <div class="ws-fin-filters__presets-track">
                  <button type="button" class="ws-fin-filters__preset" :class="{ 'ws-fin-filters__preset--active': activePreset === 'mes' }" @click="setPreset('mes')">{{ t('workspaceFinanceiroServicos.filters.esteMes') }}</button>
                  <button type="button" class="ws-fin-filters__preset" :class="{ 'ws-fin-filters__preset--active': activePreset === '30' }" @click="setPreset('30')">{{ t('workspaceFinanceiroServicos.filters.prox30') }}</button>
                  <button type="button" class="ws-fin-filters__preset" :class="{ 'ws-fin-filters__preset--active': activePreset === 'todos' }" @click="setPreset('todos')">{{ t('workspaceFinanceiroServicos.filters.todos') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="ws-fin-list-section ws-fin-list-section--recebiveis">
          <div class="ws-fin-list-head">
            <div class="ws-fin-list-head__left">
              <span class="ws-fin-list-head__icon" aria-hidden="true">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
              </span>
              <div>
                <h2 class="ws-fin-list-head__title">{{ t('workspaceFinanceiroServicos.recebiveisTitle') }}</h2>
                <p class="ws-fin-list-head__sub">{{ t('workspaceFinanceiroServicos.recebiveisSub') }}</p>
              </div>
            </div>
            <span class="ws-fin-list-head__count">{{ displayList.length }}</span>
          </div>
          <div class="ws-fin-filters__status ws-fin-tabs">
            <button
              v-for="tab in tabs"
              :key="tab.id"
              type="button"
              class="ws-fin-status-pill"
              :class="[
                `ws-fin-status-pill--${tabPillClass[tab.id]}`,
                { 'ws-fin-status-pill--active': activeTab === tab.id }
              ]"
              @click="activeTab = tab.id"
            >
              <span class="ws-fin-status-pill__dot" />
              <span class="ws-fin-status-pill__text">{{ tab.label }}</span>
              <span class="ws-fin-status-pill__count">{{ tab.count }}</span>
            </button>
          </div>
          <div v-if="!displayList.length" class="ws-fin-state ws-fin-state--empty">
            <div class="ws-fin-state__icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
            </div>
            <p>{{ t('workspaceFinanceiroServicos.emptyRecebiveis') }}</p>
          </div>
          <div v-else class="ws-fin-list-body">
            <WorkspaceFinanceiroRecebivelRow
              v-for="item in displayList"
              :key="item.key"
              :item="item"
              :toggling="togglingKey === item.key"
              :show-whats-app="whatsAppConnected"
              @open-cliente="openCliente"
              @toggle-pago="onTogglePago"
              @open-whatsapp="openWhatsapp"
              @open-financeiro="openFinanceiroCliente"
              @open-anexos="openAnexosCliente"
            />
          </div>
        </section>

        <WorkspaceContasPagarSection
          :contas="contasPagarDisplay"
          :workspace-id="workspaceId"
          :on-save="saveConta"
          @marcar-pago="marcarContaPago"
          @desmarcar-pago="desmarcarContaPago"
          @delete="deleteConta"
        />

        <section class="ws-fin-list-section ws-fin-movimentos-section">
          <div class="ws-fin-list-head">
            <div class="ws-fin-list-head__left">
              <span class="ws-fin-list-head__icon ws-fin-list-head__icon--mov" aria-hidden="true">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"/></svg>
              </span>
              <div>
                <h2 class="ws-fin-list-head__title">{{ t('workspaceFinanceiroServicos.movimentosTitle') }}</h2>
                <p class="ws-fin-list-head__sub">{{ t('workspaceFinanceiroServicos.movimentosSub') }}</p>
              </div>
            </div>
            <button type="button" class="ws-fin-filters__apply" @click="openMovimentoModal">{{ t('workspaceFinanceiroServicos.addMovimento') }}</button>
          </div>
          <div class="ws-fin-movimentos-body">
            <div v-if="!movimentosDisplay.length" class="ws-fin-state ws-fin-state--empty">
              <div class="ws-fin-state__icon" aria-hidden="true">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"/></svg>
              </div>
              <p>{{ t('workspaceFinanceiroServicos.emptyMovimentos') }}</p>
            </div>
            <div v-else class="ws-fin-list-body ws-fin-list-body--cards">
              <WorkspaceMovimentoRow
                v-for="mov in movimentosDisplay"
                :key="mov.id"
                :movimento="mov"
                @delete="deleteMovimento"
              />
            </div>
          </div>
        </section>
      </template>
    </div>

    <div
      v-if="showMovimentoForm"
      class="ws-fin-modal-overlay"
      role="presentation"
      @click.self="showMovimentoForm = false"
    >
      <div
        class="ws-fin-modal ws-fin-modal--premium"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="'ws-fin-mov-modal-title'"
        @click.stop
      >
        <header class="ws-fin-modal__header">
          <span class="ws-fin-modal__header-icon" aria-hidden="true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
            </svg>
          </span>
          <div class="ws-fin-modal__header-text">
            <h3 id="ws-fin-mov-modal-title" class="ws-fin-modal__title">{{ t('workspaceFinanceiroServicos.addMovimento') }}</h3>
            <p class="ws-fin-modal__subtitle">{{ t('workspaceFinanceiroServicos.movimentoSub') }}</p>
          </div>
          <button type="button" class="ws-fin-modal__close" :aria-label="t('common.close')" @click="showMovimentoForm = false">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </header>

        <div class="ws-fin-modal__body">
          <div class="ws-fin-modal__section">
            <span class="ws-fin-modal__label">{{ t('workspaceFinanceiroServicos.movimentoTipo') }}</span>
            <div class="ws-fin-modal__tipo-toggle" role="group" :aria-label="t('workspaceFinanceiroServicos.movimentoTipo')">
              <button
                type="button"
                class="ws-fin-modal__tipo-btn"
                :class="{ 'ws-fin-modal__tipo-btn--active': movForm.tipo === 'ENTRADA', 'ws-fin-modal__tipo-btn--entrada': movForm.tipo === 'ENTRADA' }"
                @click="movForm.tipo = 'ENTRADA'"
              >
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M7 11l5-5m0 0l5 5m-5-5v12"/></svg>
                {{ t('workspaceFinanceiroServicos.movimentoEntrada') }}
              </button>
              <button
                type="button"
                class="ws-fin-modal__tipo-btn"
                :class="{ 'ws-fin-modal__tipo-btn--active': movForm.tipo === 'GASTO', 'ws-fin-modal__tipo-btn--gasto': movForm.tipo === 'GASTO' }"
                @click="movForm.tipo = 'GASTO'"
              >
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M17 13l-5 5m0 0l-5-5m5 5V6"/></svg>
                {{ t('workspaceFinanceiroServicos.movimentoGasto') }}
              </button>
            </div>
          </div>

          <div class="ws-fin-modal__grid">
            <label class="ws-fin-modal__field">
              <span class="ws-fin-modal__label">{{ t('workspaceFinanceiroServicos.movimentoValor') }}</span>
              <div class="ws-fin-modal__input-wrap ws-fin-modal__input-wrap--money">
                <img :src="moneyIcon" alt="" class="ws-fin-modal__money-icon" aria-hidden="true" />
                <input v-model="movForm.valor" type="number" step="0.01" min="0" class="ws-fin-modal__input" :placeholder="t('workspaceFinanceiroServicos.movimentoValorPlaceholder')" />
              </div>
            </label>
            <label class="ws-fin-modal__field">
              <span class="ws-fin-modal__label">{{ t('workspaceFinanceiroServicos.movimentoData') }}</span>
              <div class="ws-fin-modal__input-wrap">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                <input v-model="movForm.dataMovimento" type="date" class="ws-fin-modal__input" />
              </div>
            </label>
          </div>

          <label class="ws-fin-modal__field ws-fin-modal__field--full">
            <span class="ws-fin-modal__label">{{ t('workspaceFinanceiroServicos.movimentoDesc') }}</span>
            <input v-model="movForm.descricao" type="text" class="ws-fin-modal__input ws-fin-modal__input--block" :placeholder="t('workspaceFinanceiroServicos.movimentoDescPlaceholder')" />
          </label>
        </div>

        <footer class="ws-fin-modal__footer">
          <button type="button" class="ws-fin-modal__btn ws-fin-modal__btn--ghost" @click="showMovimentoForm = false">{{ t('common.cancel') }}</button>
          <button type="button" class="ws-fin-modal__btn ws-fin-modal__btn--primary" @click="saveMovimento">{{ t('common.save') }}</button>
        </footer>
      </div>
    </div>

    <ClienteSideDrawer
      :open="sideDrawerOpen"
      :title="sideDrawer?.nome || sideDrawerTitle"
      :subtitle="sideDrawerSubtitle"
      :wide="sideDrawer?.tab === 'whatsapp'"
      :body-class="sideDrawerBodyClass"
      :show-header="sideDrawerShowHeader"
      :aria-label="sideDrawerSubtitle"
      @close="closeSideDrawer"
    >
      <template v-if="sideDrawer?.tab === 'financeiro'" #icon>
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      </template>
      <template v-else-if="sideDrawer?.tab === 'anexos'" #icon>
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"/></svg>
      </template>

      <WhatsAppChatPanel
        v-if="sideDrawer?.tab === 'whatsapp' && sideDrawer?.id"
        ref="waPanelRef"
        entity-type="cliente"
        :entity-id="sideDrawer.id"
        :workspace-id="workspaceId"
        :contact-name="sideDrawer.nome"
        :contact-phone="sideDrawer.telefone"
        :active="sideDrawerOpen"
        layout="tab"
        column-class="wa-drawer-chat"
        class="cliente-side-drawer-pane cliente-side-drawer-pane--fill"
      />

      <ClienteFinanceiroDrawerPanel
        v-else-if="sideDrawer?.tab === 'financeiro' && sideDrawer?.id"
        :cliente-id="sideDrawer.id"
        :active="sideDrawerOpen"
        @updated="onClienteFinanceiroUpdated"
      />

      <div
        v-else-if="sideDrawer?.tab === 'anexos' && sideDrawer?.id"
        class="cliente-side-drawer-pane cliente-side-drawer-pane--anexos p-0"
      >
        <AnexosSection :cliente-id="sideDrawer.id" icon-only-upload @anexos-updated="() => {}" />
      </div>
    </ClienteSideDrawer>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue'
import Swal from 'sweetalert2'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import api from '@/services/api'
import { useGlobalWorkspaces } from '@/composables/useGlobalWorkspaces'
import { useWorkspaceStaffGuard } from '@/composables/useWorkspaceStaffGuard'
import WorkspaceRoleDenied from '@/components/workspace/WorkspaceRoleDenied.vue'
import MoneyAmount from '@/components/MoneyAmount.vue'
import moneyIcon from '@/assets/money-icon.png'
import WorkspaceFinanceiroServicosKpi from '@/components/workspace-financeiro/WorkspaceFinanceiroServicosKpi.vue'
import WorkspaceFinanceiroServicosForecast from '@/components/workspace-financeiro/WorkspaceFinanceiroServicosForecast.vue'
import WorkspaceFinanceiroRecebivelRow from '@/components/workspace-financeiro/WorkspaceFinanceiroRecebivelRow.vue'
import WorkspaceContasPagarSection from '@/components/workspace-financeiro/WorkspaceContasPagarSection.vue'
import WorkspaceMovimentoRow from '@/components/workspace-financeiro/WorkspaceMovimentoRow.vue'
import ClienteSideDrawer from '@/components/cliente/ClienteSideDrawer.vue'
import WhatsAppChatPanel from '@/components/WhatsAppChatPanel.vue'
import ClienteFinanceiroDrawerPanel from '@/components/cliente/ClienteFinanceiroDrawerPanel.vue'
import AnexosSection from '@/components/AnexosSection.vue'
import { useWorkspaceWhatsAppWebSocket } from '@/composables/useWorkspaceWhatsAppWebSocket'
import { toggleRecebivelPago } from '@/utils/clienteRecebivelApi'
import {
  flattenRecebiveis,
  computeKpis,
  computeForecast,
  filterRecebiveisList,
  filterFinanceiroItems,
  sortRecebiveis,
  sortFinanceiroItems,
  filterByTab,
  defaultPeriodoMes,
  hojeISO,
  normalizeContaPagar,
  normalizeMovimento,
  contaPagarStatus
} from '@/utils/financeiroServicosMetrics'
import { buildMarcarPagoSwalHtml, MARCAR_PAGO_SWAL_CLASS } from '@/utils/financeiroMarcarPagoSwal'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const { currentWorkspace } = useGlobalWorkspaces()
const { staffDenied } = useWorkspaceStaffGuard(t('workspaceFinanceiroServicos.area'))

const workspaceId = computed(() => Number(route.params.id))
useWorkspaceWhatsAppWebSocket(workspaceId)
const loading = ref(false)
const clientes = ref([])
const movimentos = ref([])
const contasPagar = ref([])
const activeTab = ref('pendentes')
const search = ref('')
const sortBy = ref('vencimento')
const periodo = ref(defaultPeriodoMes())
const togglingKey = ref(null)

const showMovimentoForm = ref(false)
const movForm = ref({ tipo: 'ENTRADA', valor: '', dataMovimento: hojeISO(), descricao: '' })

const whatsAppConnected = ref(false)
const sideDrawer = ref(null)
const waPanelRef = ref(null)

const sideDrawerOpen = computed(() => !!sideDrawer.value?.id)

const sideDrawerTitle = computed(() => {
  const tab = sideDrawer.value?.tab
  if (tab === 'whatsapp') return t('workspaceClienteModal.tabs.whatsapp')
  if (tab === 'financeiro') return t('workspaceClienteModal.tabs.financeiro')
  if (tab === 'anexos') return t('workspaceClienteModal.tabs.anexos')
  return ''
})

const sideDrawerSubtitle = computed(() => {
  const tab = sideDrawer.value?.tab
  if (tab === 'whatsapp') return t('workspaceClienteModal.tabs.whatsapp')
  if (tab === 'financeiro') return t('workspaceClienteModal.tabs.financeiro')
  if (tab === 'anexos') return t('workspaceClienteModal.tabs.anexos')
  return ''
})

const sideDrawerShowHeader = computed(() => ['financeiro', 'anexos'].includes(sideDrawer.value?.tab))

const sideDrawerBodyClass = computed(() => {
  const tab = sideDrawer.value?.tab
  if (['whatsapp', 'financeiro'].includes(tab)) return 'cliente-side-drawer-body--flush'
  return ''
})

const refreshWhatsAppStatus = async () => {
  if (!workspaceId.value) {
    whatsAppConnected.value = false
    return
  }
  try {
    const r = await api.get(`/whatsapp/workspace/${workspaceId.value}`)
    whatsAppConnected.value = String(r.data?.status || '').toUpperCase() === 'CONNECTED'
  } catch {
    whatsAppConnected.value = false
  }
}

const kpis = ref({
  atrasados: { valor: 0, qtd: 0 },
  venceHoje: { valor: 0, qtd: 0 },
  proximos7: { valor: 0, qtd: 0 },
  totalAberto: { valor: 0, qtd: 0 }
})

const forecast = ref({
  mesAtual: {
    atrasados: { valor: 0, qtd: 0 },
    recebidos: { valor: 0, qtd: 0 },
    previsaoEntrada: { valor: 0, qtd: 0 },
    saldoLiquido: { valor: 0 },
    contasPendentesMes: { valor: 0, qtd: 0 }
  },
  proximoMes: { previsaoRecebiveis: { valor: 0, qtd: 0 } }
})

const allRecebiveis = computed(() => flattenRecebiveis(clientes.value))

function mapBlock (b) {
  return { valor: Number(b?.valor) || 0, qtd: b?.qtd ?? 0 }
}

function applyResumoFromApi (data) {
  if (!data?.kpis) return false
  kpis.value = {
    atrasados: mapBlock(data.kpis.atrasados),
    venceHoje: mapBlock(data.kpis.venceHoje),
    proximos7: mapBlock(data.kpis.proximos7),
    totalAberto: mapBlock(data.kpis.totalAberto)
  }
  const ma = data.forecast?.mesAtual || {}
  const pm = data.forecast?.proximoMes || {}
  forecast.value = {
    mesAtual: {
      atrasados: mapBlock(ma.atrasados),
      recebidos: mapBlock(ma.recebidos),
      previsaoEntrada: mapBlock(ma.previsaoEntrada),
      saldoLiquido: mapBlock(ma.saldoLiquido),
      contasPendentesMes: mapBlock(ma.contasPendentesMes)
    },
    proximoMes: { previsaoRecebiveis: mapBlock(pm.previsaoRecebiveis) }
  }
  return true
}

function recomputeLocalMetrics () {
  const rec = allRecebiveis.value
  kpis.value = computeKpis(rec)
  forecast.value = computeForecast(rec, movimentos.value, contasPagar.value)
}

const tabs = computed(() => {
  const rec = allRecebiveis.value
  const hoje = hojeISO()
  return [
    { id: 'pendentes', label: t('workspaceFinanceiroServicos.tabs.pendentes'), count: filterByTab(rec, 'pendentes', hoje).length },
    { id: 'pagos', label: t('workspaceFinanceiroServicos.tabs.pagos'), count: filterByTab(rec, 'pagos', hoje).length },
    { id: 'atrasados', label: t('workspaceFinanceiroServicos.tabs.atrasados'), count: filterByTab(rec, 'atrasados', hoje).length }
  ]
})

const displayList = computed(() => {
  let list = filterRecebiveisList(allRecebiveis.value, {
    search: search.value,
    inicio: periodo.value.inicio,
    fim: periodo.value.fim,
    tab: activeTab.value
  })
  return sortRecebiveis(list, sortBy.value)
})

const filterParams = computed(() => ({
  search: search.value,
  inicio: periodo.value.inicio,
  fim: periodo.value.fim
}))

const contasPagarDisplay = computed(() => {
  const list = filterFinanceiroItems(contasPagar.value, {
    ...filterParams.value,
    dateField: 'dataVencimento',
    searchFields: ['nome', 'descricao']
  })
  return sortFinanceiroItems(list, sortBy.value, {
    dateField: 'dataVencimento',
    statusFn: contaPagarStatus
  })
})

const movimentosDisplay = computed(() => {
  const list = filterFinanceiroItems(movimentos.value, {
    ...filterParams.value,
    dateField: 'dataMovimento',
    searchFields: ['descricao', 'tipo']
  })
  return sortFinanceiroItems(list, sortBy.value, { dateField: 'dataMovimento' })
})

const tabPillClass = { pendentes: 'pending', pagos: 'paid', atrasados: 'overdue' }

const activePreset = computed(() => {
  const { inicio, fim } = periodo.value
  if (!inicio && !fim) return 'todos'
  const def = defaultPeriodoMes()
  if (inicio === def.inicio && fim === def.fim) return 'mes'
  const hoje = hojeISO()
  if (inicio === hoje) {
    const fim30 = new Date()
    fim30.setDate(fim30.getDate() + 30)
    if (fim === fim30.toISOString().slice(0, 10)) return '30'
  }
  return null
})

function setPreset (preset) {
  const hoje = new Date()
  if (preset === 'mes') {
    periodo.value = defaultPeriodoMes()
  } else if (preset === '30') {
    const fim = new Date(hoje)
    fim.setDate(fim.getDate() + 30)
    periodo.value = { inicio: hojeISO(), fim: fim.toISOString().slice(0, 10) }
  } else {
    periodo.value = { inicio: '', fim: '' }
  }
}

const load = async ({ silent = false } = {}) => {
  if (!silent) loading.value = true
  try {
    const [cliRes, movRes, cpRes, resumoRes] = await Promise.all([
      api.get(`/clientes/workspace/${workspaceId.value}`),
      api.get(`/movimentos-financeiros/workspace/${workspaceId.value}`),
      api.get(`/contas-pagar-workspace/workspace/${workspaceId.value}`).catch(() => ({ data: [] })),
      api.get(`/clientes/workspace/${workspaceId.value}/financeiro/resumo`).catch(() => ({ data: null }))
    ])
    clientes.value = cliRes.data || []
    movimentos.value = (movRes.data || []).map(normalizeMovimento)
    contasPagar.value = (cpRes.data || []).map(normalizeContaPagar)
    if (!applyResumoFromApi(resumoRes.data)) {
      recomputeLocalMetrics()
    }
  } catch (error) {
    console.error(error)
    clientes.value = []
    movimentos.value = []
    contasPagar.value = []
    recomputeLocalMetrics()
  } finally {
    if (!silent) loading.value = false
  }
}

const openCliente = (id) => {
  router.push({
    name: 'WorkspaceClienteDetail',
    params: { id: workspaceId.value, clienteId: Number(id) },
    query: { from: 'financeiro' }
  })
}

const closeSideDrawer = () => {
  sideDrawer.value = null
}

const openFinanceiroCliente = (item) => {
  sideDrawer.value = {
    tab: 'financeiro',
    id: item.clienteId,
    nome: item.clienteNome
  }
}

const openAnexosCliente = (item) => {
  sideDrawer.value = {
    tab: 'anexos',
    id: item.clienteId,
    nome: item.clienteNome
  }
}

const onClienteFinanceiroUpdated = async () => {
  await load({ silent: true })
}

const openWhatsapp = async (item) => {
  const telefone = String(item.clienteWhatsapp || '').trim()
  if (!telefone) {
    await Swal.fire({
      icon: 'info',
      title: t('workspaceFinanceiroServicos.actions.whatsapp'),
      text: t('workspaceClienteModal.whatsapp.phoneMissing'),
      confirmButtonText: 'OK'
    })
    return
  }
  if (!whatsAppConnected.value) {
    await refreshWhatsAppStatus()
    if (!whatsAppConnected.value) return
  }
  sideDrawer.value = {
    tab: 'whatsapp',
    id: item.clienteId,
    nome: item.clienteNome,
    telefone
  }
  await refreshWhatsAppStatus()
  await nextTick()
  await waPanelRef.value?.refreshWhatsAppStatus?.()
  await waPanelRef.value?.loadChatHistory?.()
}

const formatValor = (valor) => {
  const n = Number(valor)
  if (!Number.isFinite(n)) return '—'
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

const onTogglePago = async (item) => {
  if (!item.pago) {
    const labels = {
      title: t('workspaceFinanceiroServicos.confirmMarcarPago.title'),
      subtitle: t('workspaceFinanceiroServicos.confirmMarcarPago.subtitle'),
      cliente: t('workspaceFinanceiroServicos.confirmMarcarPago.labelCliente'),
      valor: t('workspaceFinanceiroServicos.confirmMarcarPago.labelValor'),
      vencimento: t('workspaceFinanceiroServicos.confirmMarcarPago.labelVencimento')
    }
    const result = await Swal.fire({
      html: buildMarcarPagoSwalHtml({
        cliente: item.clienteNome,
        valor: formatValor(item.valor),
        vencimento: item.dataVencimento || null,
        labels
      }),
      showConfirmButton: true,
      showCancelButton: true,
      showCloseButton: true,
      focusConfirm: false,
      reverseButtons: true,
      buttonsStyling: false,
      customClass: MARCAR_PAGO_SWAL_CLASS,
      confirmButtonText: t('workspaceFinanceiroServicos.confirmMarcarPago.confirm'),
      cancelButtonText: t('common.cancel')
    })
    if (!result.isConfirmed) return
  }

  togglingKey.value = item.key
  try {
    await toggleRecebivelPago(item.clienteId, item)
    await load({ silent: true })
  } catch (e) {
    console.error(e)
    await Swal.fire({
      html: `<p class="ws-fin-swal__error-text">${t('workspaceFinanceiroServicos.confirmMarcarPago.error')}</p>`,
      icon: 'error',
      buttonsStyling: false,
      customClass: {
        popup: 'ws-fin-swal-popup ws-fin-swal-popup--error',
        confirmButton: 'ws-fin-swal-btn ws-fin-swal-btn--confirm'
      },
      confirmButtonText: 'OK'
    })
  } finally {
    togglingKey.value = null
  }
}

const openMovimentoModal = () => {
  movForm.value = { tipo: 'ENTRADA', valor: '', dataMovimento: hojeISO(), descricao: '' }
  showMovimentoForm.value = true
}

const saveMovimento = async () => {
  try {
    await api.post('/movimentos-financeiros', {
      workspaceId: workspaceId.value,
      tipo: movForm.value.tipo,
      valor: Number(movForm.value.valor),
      dataMovimento: movForm.value.dataMovimento,
      descricao: movForm.value.descricao
    })
    showMovimentoForm.value = false
    await load()
  } catch (error) {
    console.error(error)
  }
}

const deleteMovimento = async (id) => {
  try {
    await api.delete(`/movimentos-financeiros/${id}`)
    await load()
  } catch (error) {
    console.error(error)
  }
}

const marcarContaPago = async (id) => {
  await api.put(`/contas-pagar-workspace/${id}/marcar-pago`)
  await load({ silent: true })
}

const desmarcarContaPago = async (id) => {
  await api.put(`/contas-pagar-workspace/${id}/desmarcar-pago`)
  await load({ silent: true })
}

const deleteConta = async (id) => {
  await api.delete(`/contas-pagar-workspace/${id}`)
  await load()
}

const saveConta = async ({ id, workspaceId: wsId, nome, valor, dataVencimento, descricao, isMensal, repeticoes, recorrenciaSempre }) => {
  const body = { workspaceId: wsId, nome, valor, dataVencimento, descricao, isMensal, repeticoes, recorrenciaSempre }
  try {
    if (id) await api.put(`/contas-pagar-workspace/${id}`, body)
    else await api.post('/contas-pagar-workspace', body)
    await load({ silent: true })
  } catch (error) {
    const data = error?.response?.data
    let apiMsg = data?.error
    if (!apiMsg && typeof data === 'string') {
      try {
        apiMsg = JSON.parse(data)?.error
      } catch { /* ignore */ }
    }
    const msg = apiMsg || error?.message || t('workspaceFinanceiroServicos.contasPagar.saveError')
    await Swal.fire({
      icon: 'error',
      title: t('workspaceFinanceiroServicos.contasPagar.saveErrorTitle'),
      text: msg,
      confirmButtonText: 'OK'
    })
    throw error
  }
}

onMounted(async () => {
  await refreshWhatsAppStatus()
  await load()
})
</script>

<style src="@/assets/styles/workspace-financeiro.css"></style>
<style src="@/assets/styles/workspace-financeiro-servicos.css"></style>
<style src="@/assets/styles/cliente-modal-theme.css"></style>
